module.exports = __webpack_public_path__ + "static/media/nitclogo.d620d6db.png";